module.exports = __webpack_public_path__ + "img/imgZXGH(10).f9d20bb7.png";